import { isKnownWidgetId } from "@/components/wall/wall-layout-utils";
import { widgetMeta } from "@/components/wall/widget-meta";
import { isWallRoute } from "@/config/assistant-pointer";
import type {
	AssistantLang,
	AssistantPageContext,
	AssistantWallWidget,
} from "@/types/ai-assistant-chat";
import { pageTitleFrom } from "./assistant.logic";

/** Id + judul widget wall yang tampil; id tak dikenal katalog dibuang. Hanya nama, bukan data. */
export function wallWidgetsOf(ids: readonly string[]): AssistantWallWidget[] {
	return ids.filter(isKnownWidgetId).map((id) => ({
		id,
		title: widgetMeta(id).title,
	}));
}

/** Konteks halaman untuk tiap pertanyaan (teks & suara); `wallWidgets` hanya di rute /wall. */
export function buildPageContext(input: {
	pathname: string;
	documentTitle: string;
	lang: AssistantLang;
	wallIds: readonly string[];
}): AssistantPageContext {
	return {
		route: input.pathname,
		title: pageTitleFrom(input.documentTitle) || undefined,
		lang: input.lang,
		...(isWallRoute(input.pathname)
			? { wallWidgets: wallWidgetsOf(input.wallIds) }
			: {}),
	};
}
